export const fragenAutoVerkauf = [
  {
    question: "Was ist der beste Weg, mein Auto zu verkaufen?",
    answer: (
      <>
        <p>
          Der beste Weg, dein Auto zu verkaufen, sollte einfach, schnell und zu
          einem guten Preis sein – genau das bietet Autoeinfachlos. Wir sind
          darauf spezialisiert, dir einen unkomplizierten, fairen und
          transparenten Verkaufsprozess zu ermöglichen. Wie?
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>100 % kostenlos</strong>
          </li>
          <li>
            <strong>Komplett online,</strong> sodass du nicht von Händler zu
            Händler fahren musst
          </li>
          <li>
            <strong>Sofortige Fahrzeugbewertung</strong>
          </li>
          <li>
            <strong>Wir überprüfen unsere Händler sorgfältig,</strong> bevor wir
            sie in unser österreichweites Netzwerk aufnehmen.
          </li>

          <li>
            <strong>Kostenlose Abholung direkt bei dir zu Hause</strong>
          </li>
          <li>Verkauf in nur 24 Stunden möglich</li>
        </ul>
      </>
    ),
  },
  {
    question: "Wird mein Auto abgeholt, sobald es verkauft ist?",
    answer: (
      <>
        <p>
          Ja. Sobald der Verkauf vereinbart ist, holt der Händler dein Auto zu
          einem für dich passenden Zeitpunkt kostenlos ab. Er überprüft dein
          Fahrzeug, um sicherzustellen, dass es dem beschriebenen Profil
          entspricht. Dies umfasst normalerweise einen kurzen Blick auf die
          Karosserie, das Interieur und die grundlegende Mechanik – und manchmal
          eine kurze Probefahrt.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich mein Auto von jedem Standort aus verkaufen?",
    answer: (
      <>
        <p>
          Ja. Wenn du dein Auto an einen geprüften Händler über Autoeinfachlos
          verkaufst, wird es kostenlos von deinem Zuhause, Arbeitsplatz oder
          einer anderen geeigneten Adresse abgeholt.
        </p>
      </>
    ),
  },
  {
    question: "Zahlt Autoeinfachlos den Bestpreis?",
    answer: (
      <>
        <p>
          Ja, und das ist unser Ziel! Anders als andere Plattformen sind wir auf
          die Vermittlung von Gebrauchtwagen spezialisiert und bieten so
          entscheidende Vorteile.
        </p>

        <p>
          <strong>Der Unterschied:</strong>
        </p>

        <ul className="AV-Fragen-ul">
          <li>
            <strong>Was Ankaufsplattformen möchten:</strong> Dein Auto günstig
            kaufen und später teurer verkaufen.
          </li>
          <li>
            <strong>Was Autoeinfachlos möchte: </strong>Dein Fahrzeug zum
            bestmöglichen Preis verkaufen.
          </li>
          <li>
            Autoeinfachlos erhält eine Provision für die Vermittlung, die direkt
            vom Verkaufspreis abhängt. Je höher der Verkaufspreis, desto höher
            auch unsere Provision. Kurz gesagt:
            <strong> Wir gewinnen, wenn du gewinnst.</strong>
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Ist es besser, mein Auto an einen Händler zu verkaufen?",
    answer: (
      <>
        <p>
          Den Verkauf deines Autos an einen Händler abzuwickeln, kann einfacher
          sein, als einen privaten Käufer zu finden, da es weniger Risiko für
          Zeitverschwendung gibt – du fragst den Händler nach einem Preis, er
          macht ein Angebot, du stimmst zu (oder eben nicht), und das war’s. Der
          Nachteil dieser Bequemlichkeit ist jedoch oft, dass der Endpreis
          niedriger ausfallen könnte, als du erhofft hast.
        </p>

        <p>
          Mit Autoeinfachlos möchten wir dir das beste Angebot sichern. Durch
          die Zusammenarbeit mit über 5.000 geprüften Händlern präsentieren wir
          dein Auto Tausenden potenzieller Käufer, ganz ohne Fahrerei von
          Händler zu Händler und ohne zusätzlichen Verwaltungsaufwand. Du kannst
          innerhalb von 24 Stunden online einem Verkauf zustimmen – komplett
          kostenlos.
        </p>
      </>
    ),
  },
  {
    question: "Wo kann ich mein Auto zum Bestpreis verkaufen?",
    answer: (
      <>
        <p>
          Bei Autoeinfachlos stellen wir sicher, dass du das beste Angebot von
          geprüften Autohändlern erhältst – ohne Gebühren oder Provisionen.
        </p>

        <p>
          Sieh dir unseren Leitfaden an, um weitere Tipps zu bekommen, wie du
          beim Verkauf den höchsten Preis für dein Auto erzielen kannst.
        </p>
      </>
    ),
  },
  {
    question:
      "Welche Vorteile bietet mir Autoeinfachlos bei meinem Autoverkauf?",
    answer: (
      <>
        <p>
          Autoeinfachlos macht den Autoverkauf einfach, schnell und transparent
          und bietet dir entscheidende Vorteile:
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Bestpreis-Garantie: </strong> Durch unser Vermittlungsmodell
            konkurrieren über 5.000 geprüfte Händler um dein Auto, sodass du das
            beste Angebot erhältst.
          </li>
          <li>
            <strong>100 % kostenlos: </strong>Der gesamte Prozess – von der
            Fahrzeugbewertung bis zur Abholung – ist für dich komplett
            kostenfrei.
          </li>
          <li>
            <strong>Komfort und Bequemlichkeit: </strong>Kein mühsames Fahren
            von Händler zu Händler. Wir erledigen alles online, und der Käufer
            holt dein Auto direkt bei dir zu Hause ab.
          </li>
          <li>
            <strong>Objektive Bewertung: </strong>Du erhältst von uns eine
            objektive Bewertung, unabhängig vom Händler, damit du genau weißt,
            wie viel dein Auto wert ist.
          </li>
          <li>
            <strong>Schnelle Abwicklung: </strong>Innerhalb von 24 Stunden
            kannst du ein Angebot erhalten und den Verkauf abschließen.
          </li>
        </ul>
        <br />

        <p>
          Mit Autoeinfachlos sparst du Zeit und Aufwand und sicherst dir
          gleichzeitig den besten Preis für dein Fahrzeug.
        </p>
      </>
    ),
  },
  {
    question: "Welche Dokumente benötige ich für den Autoverkauf?",
    answer: (
      <>
        <p>
          <strong>
            Für den Verkauf deines Autos benötigst du folgende Dokumente:
          </strong>
        </p>
        <ol className="AV-Fragen-ol">
          <li>
            <strong>Fahrzeugschein (Zulassungsbescheinigung Teil I)</strong>
            <br />
            Dokumentiert die Fahrzeugdaten und ist für die Abmeldung
            erforderlich.
          </li>
          <li>
            <strong>Fahrzeugbrief (Zulassungsbescheinigung Teil II)</strong>
            <br />
            Nachweis des Eigentums und ebenfalls notwendig für die Abmeldung.
          </li>
          <li>
            <strong>Personalausweis oder Reisepass</strong>
            <br />
            Zur Identifikation und Bestätigung des Verkaufs.
          </li>
          <li>
            <strong>Serviceheft und Inspektionsnachweise </strong>(falls
            vorhanden)
            <br />
            Dokumentiert Wartungen und Inspektionen und kann den Verkaufswert
            steigern.
          </li>
          <li>
            <strong>Alle verfügbaren Fahrzeugschlüssel</strong>
            <br />
            Einschließlich Ersatzschlüssel.
          </li>
        </ol>
        <br />

        <p>
          Sobald du einen Abholtermin gebucht hast, senden wir dir eine&nbsp;
          <strong>
            detaillierte E-Mail mit allen erforderlichen Unterlagen&nbsp;
          </strong>
          und Informationen, damit du genau weißt, was du vorbereiten musst.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich ein finanziertes Auto verkaufen?",
    answer: (
      <>
        <p>
          Ja, du kannst dein finanziertes Auto über Autoeinfachlos verkaufen.
        </p>

        <p>
          Wenn du bereit bist, dein finanziertes Auto zu verkaufen, ist der
          erste Schritt, den „Ablösebetrag“ von deiner Bank zu erhalten und eine
          Fahrzeugbewertung durchzuführen. Lies mehr in unserem Leitfaden zum
          Verkauf deines finanzierten Autos in Österreich.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich mein Auto ohne gültiges Pickerl verkaufen?",
    answer: (
      <>
        <p>
          Ja, in Österreich sowie bei uns auf Autoeinfachlos ist es erlaubt, ein
          Fahrzeug auch ohne gültige §57a-Plakette zu verkaufen. Ist das
          Fahrzeug allerdings bereits abgemeldet, darf es nicht mehr im
          öffentlichen Verkehr bewegt werden, was den Verkaufsprozess etwas
          erschweren kann.
        </p>
        <p>Idealerweise verkaufst du dein Auto vor der Abmeldung.</p>
      </>
    ),
  },
];

export const fragenNotverkauf = [
  {
    question: "Wie schnell kann ich mein Auto verkaufen?",
    answer: (
      <>
        <p>
          In der Regel innerhalb von 24 Stunden - von der Bewertung bis zum
          verbindlichen Angebot.
        </p>
      </>
    ),
  },
  {
    question: "Muss mein Auto fahrbereit sein?",
    answer: (
      <>
        <p>
          Nein. Auch defekte oder nicht fahrbereite Fahrzeuge werden über unser
          Händlernetzwerk angekauft.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Bezahlung ab?",
    answer: (
      <>
        <p>
          Nach Vertragsabschluss erfolgt die sofortige Auszahlung.
        </p>
      </>
    ),
  },
  {
    question: "Wer holt das Auto ab?",
    answer: (
      <>
        <p>
          Der Käufer organisiert die Abholung direkt bei dir zu Hause -
          kostenlos und österreichweit.
        </p>
      </>
    ),
  },
];

export const fragenWirkaufendeinauto = [
  {
    question: "Was ist der beste Weg, mein Auto zu verkaufen?",
    answer: (
      <>
        <p>
          Der beste Weg, dein Auto zu verkaufen, sollte einfach, schnell und zu
          einem guten Preis sein – genau das bietet Autoeinfachlos. Wir sind
          darauf spezialisiert, dir einen unkomplizierten, fairen und
          transparenten Verkaufsprozess zu ermöglichen. Wie?
        </p>

        <ul className="AV-Fragen-ul">
          <li>
            <strong>100 % kostenlos</strong>
          </li>
          <li>
            <strong>Komplett online,</strong>
            sodass du nicht von Händler zu Händler fahren musst
          </li>
          <li>
            <strong>Sofortige Fahrzeugbewertung</strong>
          </li>
          <li>
            <strong>Wir überprüfen unsere Händler sorgfältig,</strong>
            bevor wir sie in unser österreichweites Netzwerk aufnehmen.
          </li>
          <li>
            <strong>Kostenlose Abholung direkt bei dir zu Hause</strong>
          </li>
          <li>Verkauf in nur 24 Stunden möglich</li>
        </ul>
      </>
    ),
  },
  {
    question: "Zahlt Autoeinfachlos den Bestpreis?",
    answer: (
      <>
        <p>
          Ja, und das ist unser Ziel! Anders als andere Plattformen sind wir auf
          die Vermittlung von Gebrauchtwagen spezialisiert und bieten so
          entscheidende Vorteile.
        </p>
        <p>
          <strong>Der Unterschied:</strong>
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Was Ankaufsplattformen möchten:</strong>
            <br />
            Dein Auto günstig kaufen und später teurer verkaufen.
          </li>
          <li>
            <strong>Was Autoeinfachlos möchte:</strong>
            <br />
            Dein Fahrzeug zum bestmöglichen Preis verkaufen
          </li>
        </ul>
        <p>
          Autoeinfachlos erhält eine Provision für die Vermittlung, die direkt
          vom Verkaufspreis abhängt. Je höher der Verkaufspreis, desto höher
          auch unsere Provision. Kurz gesagt:{" "}
          <strong>Wir gewinnen, wenn du gewinnst.</strong>
        </p>
      </>
    ),
  },
  {
    question: "Wirkaufendeinauto vs Autoeinfachlos",
    answer: (
      <>
        <p>
          <strong>Wirkaufendeinauto:</strong>
          <br />
          Wirkaufendeinauto kauft dein Auto direkt an und verkauft es später mit
          Gewinn weiter. Dabei wird meist ein niedriger Ankaufspreis geboten, um
          die Gewinnspanne beim Weiterverkauf zu maximieren. Der Verkaufsprozess
          erfordert in der Regel einen Besuch in einer Filiale, wo das Fahrzeug
          geprüft wird, bevor ein finales Angebot gemacht wird.
        </p>
        <p>
          <strong>Autoeinfachlos:</strong>
          <br />
          Autoeinfachlos vermittelt dein Fahrzeug an über 5.000 geprüfte Händler
          in ganz Österreich. Diese Händler bieten in einer Auktion um dein
          Auto, sodass du garantiert den besten Preis erhältst. Der gesamte
          Prozess ist digital, bequem von zu Hause aus durchführbar und dein
          Auto wird kostenlos an einem Ort deiner Wahl abgeholt.
        </p>

        <p>
          <strong>Weitere Vorteile von Autoeinfachlos:</strong>
        </p>

        <ul className="AV-Fragen-ul">
          <li>
            Keine versteckten Kosten oder Gebühren – du erhältst den vollen
            Höchstpreis.
          </li>
          <li>
            Schneller Verkaufsprozess – dein Auto kann innerhalb von 24 Stunden
            verkauft werden.
          </li>
          <li>
            Bequemlichkeit – keine Filialbesuche, alles wird online und vor Ort
            abgewickelt.
          </li>
        </ul>
      </>
    ),
  },
  {
    question:
      "Welche Vorteile bietet mir Autoeinfachlos bei meinem Autoverkauf?",
    answer: (
      <>
        <p>
          Autoeinfachlos macht den Autoverkauf einfach, schnell und transparent
          und bietet dir entscheidende Vorteile:
        </p>

        <ul className="AV-Fragen-ul">
          <li>
            <strong>Bestpreis-Garantie: </strong>Durch unser Vermittlungsmodell
            konkurrieren über 5.000 geprüfte Händler um dein Auto, sodass du das
            beste Angebot erhältst.
          </li>
          <li>
            <strong>100 % kostenlos: </strong>Der gesamte Prozess – von der
            Fahrzeugbewertung bis zur Abholung – ist für dich komplett
            kostenfrei.
          </li>
          <li>
            <strong>Komfort und Bequemlichkeit: </strong>
            Kein mühsames Fahren von Händler zu Händler. Wir erledigen alles
            online, und der Käufer holt dein Auto direkt bei dir zu Hause ab.
          </li>
          <li>
            <strong>Objektive Bewertung: </strong>
            Du erhältst von uns eine objektive Bewertung, unabhängig vom
            Händler, damit du genau weißt, wie viel dein Auto wert ist.
          </li>
          <li>
            <strong>Schnelle Abwicklung: </strong>
            Innerhalb von 24 Stunden kannst du ein Angebot erhalten und den
            Verkauf abschließen.
          </li>
        </ul>
        <p>
          Mit Autoeinfachlos sparst du Zeit und Aufwand und sicherst dir
          gleichzeitig den besten Preis für dein Fahrzeug.
        </p>
      </>
    ),
  },
  {
    question: "Ist es besser, mein Auto an einen Händler zu verkaufen?",
    answer: (
      <>
        <p>
          Den Verkauf deines Autos an einen Händler abzuwickeln, kann einfacher
          sein, als einen privaten Käufer zu finden, da es weniger Risiko für
          Zeitverschwendung gibt – du fragst den Händler nach einem Preis, er
          macht ein Angebot, du stimmst zu (oder eben nicht), und das war’s. Der
          Nachteil dieser Bequemlichkeit ist jedoch oft, dass der Endpreis
          niedriger ausfallen könnte, als du erhofft hast.
        </p>
        <p>
          Mit Autoeinfachlos möchten wir dir das beste Angebot sichern. Durch
          die Zusammenarbeit mit über 5.000 geprüften Händlern präsentieren wir
          dein Auto Tausenden potenzieller Käufer, ganz ohne Fahrerei von
          Händler zu Händler und ohne zusätzlichen Verwaltungsaufwand. Du kannst
          innerhalb von 24 Stunden online einem Verkauf zustimmen – komplett
          kostenlos.
        </p>
      </>
    ),
  },
  {
    question: "Ist die Fahrzeugbewertung und Abholung kostenlos?",
    answer: (
      <>
        <p>
          <strong>Ja, </strong>bei Autoeinfachlos sind sowohl die{" "}
          <strong>Fahrzeugbewertung </strong>
          als auch die <strong>Abholung </strong> deines Autos
          <strong> völlig kostenlos. </strong>
          Es entstehen für dich <strong> keinerlei versteckte Kosten </strong>
          oder Gebühren. Unser Ziel ist es, den Verkaufsprozess für dich so
          einfach und transparent wie möglich zu gestalten.
        </p>
        <p>
          Du kannst dein Auto bequem online bewerten lassen, und unser Team holt
          es zum vereinbarten Termin direkt bei dir vor Ort ab –
          <strong> ohne zusätzliche Kosten</strong> für dich. Wir übernehmen
          sogar die Abmeldung deines Fahrzeugs, sodass du dich um nichts kümmern
          musst.
        </p>
      </>
    ),
  },
  {
    question: "Welche Dokumente benötige ich für den Autoverkauf?",
    answer: (
      <>
        <p>
          <strong>
            Für den Verkauf deines Autos benötigst du folgende Dokumente:
          </strong>
        </p>
        <ol className="AV-Fragen-ol">
          <li>
            <strong>Fahrzeugschein (Zulassungsbescheinigung Teil I)</strong>
            <br />
            Dokumentiert die Fahrzeugdaten und ist für die Abmeldung
            erforderlich.
          </li>
          <li>
            <strong>Fahrzeugbrief (Zulassungsbescheinigung Teil II)</strong>
            <br />
            Nachweis des Eigentums und ebenfalls notwendig für die Abmeldung.
          </li>
          <li>
            <strong>Serviceheft und Inspektionsnachweise</strong>(falls
            vorhanden)
            <br />
            Dokumentiert Wartungen und Inspektionen und kann den Verkaufswert
            steigern.
          </li>
          <li>
            <strong>Alle verfügbaren Fahrzeugschlüssel</strong>
            <br />
            Einschließlich Ersatzschlüssel.
          </li>
        </ol>

        <p>
          Sobald du einen Abholtermin gebucht hast, senden wir dir eine
          <strong>
            {" "}
            detaillierte E-Mail mit allen erforderlichen Unterlagen{" "}
          </strong>
          und Informationen, damit du genau weißt, was du vorbereiten musst.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich ein finanziertes Auto verkaufen?",
    answer: (
      <>
        <p>
          Ja, du kannst dein finanziertes Auto über Autoeinfachlos verkaufen.
        </p>
        <p>
          Wenn du bereit bist, dein finanziertes Auto zu verkaufen, ist der
          erste Schritt, den „Ablösebetrag“ von deiner Bank zu erhalten und eine
          Fahrzeugbewertung durchzuführen. Lies mehr in unserem Leitfaden zum
          Verkauf deines finanzierten Autos in Österreich.
        </p>
      </>
    ),
  },
  {
    question: "Ich habe noch weitere Fragen. Wie kann ich euch erreichen?",
    answer: (
      <>
        <p>
          Kein Problem, wir sind jederzeit für dich da und beantworten dir gerne
          alle offenen Fragen.
        </p>

        <p>
          Du erreichst uns immer Werktags von 09:00 Uhr - 19:00 Uhr und Samstags
          von 10:00 Uhr - 18:00 Uhr per Telefon: +43 720 881186
        </p>
        <p>
          Du kannst uns auch gerne eine E-Mail schreiben:
          service@autoeinfachlos.at
        </p>
      </>
    ),
  },
];

export const fragenTirol = [
  {
    question: "Kann ich mein Auto in Tirol auch mit Schäden verkaufen?",
    answer: (
      <>
        <p>
          Ja, egal ob Unfallauto, Motorschaden oder Getriebeschaden, du kannst
          es über Autoeinfachlos anbieten.
        </p>
      </>
    ),
  },
  {
    question: "Wie funktioniert die Abholung in Tirol?",
    answer: (
      <>
        <p>
          Nach dem Zuschlag vereinbart der Händler einen Termin und holt dein
          Auto direkt bei dir ab.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich?",
    answer: (
      <>
        <p>
          Zulassungsschein, Typenschein, Serviceheft falls vorhanden und beide
          Schlüssel.
        </p>
      </>
    ),
  },
];

export const fragenVorarlberg = [
  {
    question: "Kann ich ein Auto ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, auch Autos ohne gültiges Pickerl oder mit Mängeln können verkauft
          werden. Dazu zählen Motorschaden, Unfallauto oder Getriebeschaden.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Abholung ab?",
    answer: (
      <>
        <p>
          Der Händler kommt direkt zu dir nach Hause, egal ob in Bludenz,
          Dornbirn oder am Arlberg.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich?",
    answer: (
      <>
        <p>
          Zulassungsschein, Typenschein, Serviceheft falls vorhanden und beide
          Schlüssel. Unser Support hilft dir bei Fragen.
        </p>
      </>
    ),
  },
];

export const fragenWien = [
  {
    question: "Kann ich mein Auto in Wien auch ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, über Autoeinfachlos kannst Du auch Fahrzeuge ohne gültiges Pickerl
          oder mit Schäden verkaufen.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Abholung in Wien ab?",
    answer: (
      <>
        <p>
          Sobald der Verkauf abgeschlossen ist, holt der Händler dein Auto
          kostenlos zu einem für dich passenden Zeitpunkt in Wien ab. Dabei
          überprüft er dein Fahrzeug, um sicherzustellen, dass es mit dem
          erstellten Profil übereinstimmt. Dies beinhaltet in der Regel eine
          kurze Kontrolle des Außenbereichs, des Innenraums und der allgemeinen
          Mechanik, sowie manchmal eine kurze Probefahrt.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich für den Verkauf?",
    answer: (
      <>
        <p>
          Notwendig sind Zulassungsschein, Typenschein, Serviceheft und beide
          Fahrzeugschlüssel.
        </p>
      </>
    ),
  },
];

export const fragenKaernten = [
  {
    question: "Kann ich mein Auto in Kärnten auch ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, über Autoeinfachlos kannst Du auch Fahrzeuge ohne gültiges Pickerl
          oder mit Schäden verkaufen.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Abholung in Kärnten ab?",
    answer: (
      <>
        <p>
          Sobald der Verkauf abgeschlossen ist, holt der Händler dein Auto
          kostenlos zu einem für dich passenden Zeitpunkt in Kärnten ab. Dabei
          überprüft er dein Fahrzeug, um sicherzustellen, dass es mit dem
          erstellten Profil übereinstimmt. Dies beinhaltet in der Regel eine
          kurze Kontrolle des Außenbereichs, des Innenraums und der allgemeinen
          Mechanik, sowie manchmal eine kurze Probefahrt.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich für den Verkauf?",
    answer: (
      <>
        <p>
          Notwendig sind Zulassungsschein, Typenschein, Serviceheft und beide
          Fahrzeugschlüssel.
        </p>
      </>
    ),
  },
];

export const fragenNiederoesterreich = [
  {
    question: "Kann ich ein Auto ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, auch Autos ohne gültiges Pickerl oder mit Mängeln können verkauft
          werden. Dazu zählen Motorschaden, Unfallauto oder Getriebeschaden.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Abholung ab?",
    answer: (
      <>
        <p>
          Der Händler kommt direkt zu dir nach Hause, egal ob in St. Pölten,
          Wiener Neustadt, Krems, Amstetten oder im Mostviertel.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich?",
    answer: (
      <>
        <p>
          Zulassungsschein, Typenschein, Serviceheft falls vorhanden und beide
          Schlüssel. Unser Support hilft dir bei Fragen.
        </p>
      </>
    ),
  },
];

export const fragenOberoesterreich = [
  {
    question: "Kann ich mein Auto auch ohne Pickerl verkaufen?",
    answer: (
      <>
        <p>
          Ja, du kannst Fahrzeuge ohne gültiges Pickerl oder mit Schäden
          problemlos anbieten.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Abholung ab?",
    answer: (
      <>
        <p>
          Der Händler vereinbart mit dir einen Termin und holt das Auto direkt
          bei dir ab, egal ob in der Stadt oder am Land.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich?",
    answer: (
      <>
        <p>
          Zulassungsschein, Typenschein, Serviceheft falls vorhanden und beide
          Fahrzeugschlüssel.
        </p>
      </>
    ),
  },
];

export const fragenBurgenland = [
  {
    question: "Kann ich ein Auto ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, auch Fahrzeuge ohne gültiges Pickerl kannst du problemlos
          verkaufen. Händler aus unserem Netzwerk nehmen diese Autos an.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Abholung ab?",
    answer: (
      <>
        <p>
          Ein Händler aus deiner Region holt das Auto kostenlos bei dir zuhause
          ab.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich?",
    answer: (
      <>
        <p>
          In der Regel Zulassungsschein, Typenschein und beide Autoschlüssel.
          Falls du noch eine offene Finanzierung hast, helfen wir dir ebenfalls
          weiter.
        </p>
      </>
    ),
  },
];

export const fragenSteiermark = [
  {
    question: "Kann ich ein Auto ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, auch Fahrzeuge ohne gültiges Pickerl kannst du problemlos
          verkaufen. Händler aus unserem Netzwerk nehmen diese Autos an.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Abholung ab?",
    answer: (
      <>
        <p>
          Ein Händler aus deiner Region holt das Auto kostenlos bei dir zuhause
          ab.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich?",
    answer: (
      <>
        <p>
          In der Regel Zulassungsschein, Typenschein und beide Autoschlüssel.
          Falls du noch eine offene Finanzierung hast, helfen wir dir ebenfalls
          weiter.
        </p>
      </>
    ),
  },
];

export const fragenSalzburg = [
  {
    question: "Kann ich ein Auto ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, auch Autos ohne gültiges Pickerl oder mit Mängeln können verkauft
          werden. Dazu zählen Motorschaden, Unfallauto oder Getriebeschaden.
        </p>
      </>
    ),
  },
  {
    question: "Wie läuft die Abholung ab?",
    answer: (
      <>
        <p>
          Der Händler kommt direkt zu dir nach Hause, egal ob in der Stadt
          Salzburg, im Flachgau oder im Pinzgau.
        </p>
      </>
    ),
  },
  {
    question: "Welche Unterlagen brauche ich?",
    answer: (
      <>
        <p>
          Zulassungsschein, Typenschein, Serviceheft falls vorhanden und beide
          Schlüssel. Unser Support hilft dir bei Fragen.
        </p>
      </>
    ),
  },
];
